import {Component} from 'react';
import { connect } from "react-redux";
import TextFilter from './TextFilter';
import SelectFilter from './SelectFilter';
import { Button, Container, Row, Col } from 'react-bootstrap'
import { minusIcon, searchIcon } from "../../../img/font_awesome/font_awesome"
import translations from "../../../config/translation/home_translations.json"

const mapStateToProps = state => {
    return {
      language: state.languageReducer ? state.languageReducer : 'ENGLISH'
    };
}

class PageBanner extends Component {
   render() {
   
      let textFilterComponent = '';
      if (this.props.textFilterProps && this.props.textFilterProps.filterText) {
         textFilterComponent =<><span> <Button variant="secondary" onClick={this.props.textFilterProps.textFilterReset} aria-label='Reset text filter'>{minusIcon} {this.props.textFilterProps.filterText}</Button></span></>   
      } else if (this.props.textFilterProps) {
         textFilterComponent =  <span style={{ display:'inline-block', marginLeft: 20 }}><TextFilter textFilterProps={this.props.textFilterProps}></TextFilter></span>
      } 

      let selectFilterComponent = '';
      if (this.props.selectFilterProps) {
         selectFilterComponent = <span style={{ display:'inline-block', marginLeft: 20 }}><SelectFilter selectFilterProps={this.props.selectFilterProps}></SelectFilter></span>
      }

      let finderFilterComponent = '';
      if (this.props.finderFilterProps && this.props.finderFilterProps.id > 0) {
         finderFilterComponent =<><span> <Button variant="secondary" onClick={this.props.finderFilterProps.finderFilterReset}>{minusIcon} {this.props.finderFilterProps.name}</Button></span></>   
      } else if (this.props.finderFilterProps) {
         finderFilterComponent = <span style={{ display:'inline-block'}}>
            <Container style={{ paddingRight: 0}} >
               <Row>
                  <Col><Button className='btn-outline-primary' onClick={this.props.finderFilterProps.finderFilterClick} aria-label='Email Address Lookup'>{translations[this.props.language].email_address}  {searchIcon}</Button></Col>
               </Row>
            </Container>
         </span> 
      }

      let finderFilterComponent2 = '';
      if (this.props.finderFilterProps2 && this.props.finderFilterProps2.id > 0) {
         finderFilterComponent2 =<><span> <Button variant="secondary" onClick={this.props.finderFilterProps2.finderFilterReset}>{minusIcon} {this.props.finderFilterProps2.name}</Button></span></>   
      } else if (this.props.finderFilterProps2) {
         finderFilterComponent2 = <span style={{ display:'inline-block'}}>
            <Container style={{ paddingRight: 0}} >
               <Row>
                  <Col><Button className='btn-outline-primary' onClick={this.props.finderFilterProps2.finderFilterClick} aria-label='Phone Number  Lookup'>{translations[this.props.language].phone} {searchIcon}</Button></Col>
               </Row>
            </Container>
         </span> 
      }

      let finderFilterComponent3 = '';
      if (this.props.finderFilterProps3 && this.props.finderFilterProps3.id > 0) {
         finderFilterComponent3 =<><span> <Button variant="secondary" onClick={this.props.finderFilterProps3.finderFilterReset}>{minusIcon} {this.props.finderFilterProps3.name}</Button></span></>   
      } else if (this.props.finderFilterProps3) {
         finderFilterComponent3 = <span style={{ display:'inline-block'}}>
            <Container style={{ paddingRight: 0}} >
               <Row>
                  <Col><Button className='btn-outline-primary' onClick={this.props.finderFilterProps3.finderFilterClick} aria-label='User Lookup'>User {searchIcon}</Button></Col>
               </Row>
            </Container>
         </span> 
      }

      let criteriaList = '';
      if (this.props.searchCriteria) {
         criteriaList = this.props.searchCriteria.map(criteria => {
            return <ul style={{ display: 'inline-block', marginBottom: 0, listStyleType: 'none', paddingLeft:10, fontSize: 14 }}><li style={{ textDecoration: "underline" }} >{ criteria.description}</li><li style={{ textAlign: "center" }}>{criteria.value}</li></ul>
         });
      }
   
      let buttonList = '';
      if (this.props.buttons) {
         buttonList = this.props.buttons.map((button) => {
            let buttonClassName = button.className;
            if (!buttonClassName) {
               buttonClassName = "btn btn-primary";
            }
            return (<><button className={buttonClassName} onClick={button.onClickAction} >{button.icon} {button.label}</button>&nbsp;</>)
         })
      }

      // let standoutButton = 

      return (
         <div style={{ backgroundColor: 'antiqueWhite', color: '#145A7B', paddingTop: 10, paddingBottom: 10, paddingLeft: 10, marginTop: 5, marginLeft:4, marginRight:4 }}>
            {this.props.pageHeading}
            {textFilterComponent}
            {selectFilterComponent}
            {finderFilterComponent}
            {finderFilterComponent2}
            {finderFilterComponent3}
            <span style={{ marginRight: 20 }}>{criteriaList}</span>
            <span style={{ float: 'right', marginRight: 10 }}>{buttonList}</span>
         </div>
      )
   }
}

export default connect(mapStateToProps)(PageBanner);